module.exports = __webpack_public_path__ + "static/media/35.b7d11e5d.png";